import React from 'react';

import {
  Appointment,
  AppointmentProduct,
  AppointmentType,
  isAppointmentType,
  Membership
} from 'kb-shared';
import { isCoachingAppointment } from 'kb-shared/utilities/appointment.helper';

import { TermsDetails } from './TermsDetails';

interface Props {
  appointment: Appointment | AppointmentType | Membership;
  product: AppointmentProduct<AppointmentType>;
  paymentTermsChecked?: boolean;
  onPaymentTermsChecked: (checked: boolean) => void;
}

export const ConfirmDetails = (props: Props) => {
  const { product, paymentTermsChecked = false, onPaymentTermsChecked } = props;

  if (!isAppointmentType(product.data)) return null;

  return (
    <TermsDetails
      selected={paymentTermsChecked}
      onCheckBoxSelected={() => onPaymentTermsChecked(!paymentTermsChecked)}
      showSessionDisclaimerCharge={
        isCoachingAppointment(product.data) &&
        !product.data?.shouldChargeAtBooking &&
        product.data.rateCents !== 0
      }
    />
  );
};
